import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './cashout-momo-form.scss'
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";
import { makeMomoCashoutTransaction } from '../../../services/transaction-service';

const orderSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .length(5, 'PIN must be exactly 5 characters')
    .matches(
      /^([0-9]){0,5}/,
      'PIN should be numeric. No special characters allowed'
    ),
  momoDepositNumber: Yup.string()
    .transform( phone => phone.replace(/\+/, ''))
    .required('This field is required'),
  momoDepositName: Yup.string()
    .required('This field is required')
});

const CashoutMomoForm = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    // console.log(`Submitting the following data ${JSON.stringify(values)}`);
    makeMomoCashoutTransaction(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setMessage(`${res.message}. You can close this page and return to the app`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          momoDepositNumber: "",
          momoDepositName: "",
          id: userId,
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={orderSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <p>Veuillez remplir le formulaire pour confirmer le retrait (withdrawal).</p>
            </div>
            <div className={`field`}>
              <label htmlFor="momoDepositNumber">Numéro de retrait (Number to withdraw to)*</label>
              <input
                name="momoDepositNumber"
                id="momoDepositNumber"
                placeholder="Numéro de reception (ex: 2507xxxxx)"
                value={values.momoDepositNumber}
                onChange={handleChange} />
              {errors.momoDepositNumber && touched.momoDepositNumber ? (
                <div className="error">{errors.momoDepositNumber}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="momoDepositName">Name*</label>
              <input
                name="momoDepositName"
                id="momoDepositName"
                placeholder="Cashout name"
                value={values.momoDepositName}
                onChange={handleChange} />
              {errors.momoDepositName && touched.momoDepositName ? (
                <div className="error">{errors.momoDepositName}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN code</label>
              <input
                type='password'
                name="pin"
                id="pin"
                placeholder="Votre code PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRMER</span>}
              {/* {isLoading && <span>Sending ...</span>} */}
              <BeatLoader
                color={"#fff"}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
        </p>
      }
    </div>
  );
};

export default CashoutMomoForm;
